<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Mkb-winstvrijstelling
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De mkb-winstvrijstelling is een aftrekpost op de winst. Je krijgt deze vrijstelling als je ondernemer
                bent. Maar je krijgt geen mkb-winstvrijstelling over de winst die je behaalt als medegerechtigde of
                geldverstrekker.
                <div class="space10"></div>
                De mkb-winstvrijstelling is {{ this.mkbWinstvrijstelling }}% van het gezamenlijke bedrag van de behaalde belastbare winst uit 1 of meer
                ondernemingen. Om de mkb-winstvrijstelling te bepalen, moet je deze winst eerst verminderen met de
                ondernemersaftrek.
                <div class="space10"></div>
                Als de onderneming verlies lijdt, verkleint de mkb-winstvrijstelling het verlies.
            </div>
        </div>
    </div>

</div>

